import { TabsList } from '@radix-ui/react-tabs'
import styled from 'styled-components'
import { BORDER_WIDTH, COLOR_INTENT } from 'Theme'

export const List = styled(TabsList)`
  width: 100%;
  display: flex;
  border-bottom: ${BORDER_WIDTH.PX_1} solid ${COLOR_INTENT.TABS.BORDER.BASE};
`
